import React from 'react'
import Modal from '@/components/ui/Modal'
import { ReactComponent as ZendeskIcon } from '@/assets/icons/zendesk.svg'
import Typography from '@/components/ui/Typography'
import { WebhookSection, TriggersSection } from '@/features/zendesk-app'
import Button from '@/components/ui/Buttons/Button'
import classes from './ZendeskModal.module.scss'
import { useOpenDeployArticle } from './ZendeskModal.hooks'

export type ZendeskModalProps = {
  onClose: () => void
  projectId: number
  routeId: number
}

export const ZendeskModal = ({ projectId, routeId, onClose }: ZendeskModalProps) => {
  const openDeployArticle = useOpenDeployArticle()

  return (
    <Modal onClose={onClose} isOpen>
      <Modal.Header>
        <div>
          <Modal.Icon>
            <ZendeskIcon />
          </Modal.Icon>
          <Typography variant={'xl'}>Deploy route to Zendesk</Typography>
        </div>
        <div>
          <Modal.Close onClick={onClose} />
        </div>
      </Modal.Header>
      <Modal.Content>
        <div className={classes.root}>
          <WebhookSection projectId={projectId} routeId={routeId} />
          <TriggersSection projectId={projectId} routeId={routeId} />
        </div>
      </Modal.Content>
      <Modal.Footer>
        <Button variant={'outlined'} color={'neutral'} onClick={openDeployArticle}>
          Guide how to set up ?
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
